import React from 'react';
import '../assets/css/Home.css';

function Home() {
  return (
    <section id="home" className="home">
      <h1>Peony Technologies</h1>
      <h2>شركة فلسطينية رائدة في الحلول البرمجية والمستقبل الرقمي</h2>
      <div className="wave wave1"></div>
      <div className="wave wave2"></div>
      <div className="wave wave3"></div>
    </section>
  );
}

export default Home;
